import { Braces } from 'lucide-react';
import React from 'react';
import { toast } from 'sonner';

import { Switch } from '@/components/ui/switch';
import { useStore } from '@/store';

export function DeveloperModeSection() {
  const { testModeEnabled, setTestModeEnabled } = useStore();

  const handleToggle = () => {
    const newState = !testModeEnabled;

    try {
      setTestModeEnabled(newState);

      if (newState) {
        toast.success('Developer mode enabled - Using sandbox environment', {
          duration: 4000,
        });
      } else {
        toast.success('Developer mode disabled - Using live environment', {
          duration: 4000,
        });
      }

      // Reload the page to ensure all data is fetched from the correct endpoint
      // so the UI shows the correct data for the current mode.
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } catch (error) {
      console.error('Failed to toggle developer mode:', error);
      toast.error('Failed to toggle developer mode');
    }
  };

  return (
    <div className="mt-6 rounded-lg border bg-card p-6">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-muted">
            <Braces
              className={`h-6 w-6 ${testModeEnabled ? 'text-orange-600' : 'text-foreground'}`}
            />
          </div>
          <div>
            <h3 className="text-sm font-semibold">Developer Mode</h3>
            <p className="text-sm text-muted-foreground">
              Route requests to the sandbox environment for testing. The page reloads when toggled.
            </p>
          </div>
        </div>

        <Switch
          id="developer-mode-toggle"
          checked={testModeEnabled}
          onCheckedChange={handleToggle}
          aria-label={testModeEnabled ? 'Disable developer mode' : 'Enable developer mode'}
          className="shrink-0 data-[state=checked]:bg-orange-600"
        />
      </div>
    </div>
  );
}
